module.exports = __webpack_public_path__ + "static/media/Inspection_Report_Template_1.fc73f0e9.png";